import { buildGraphqlQuery } from '@ztechapps/common.utils'

import { gql } from '@apollo/client'
import { uomReferenceFragment } from '@ztechapps/product.common'

export const productTooltipFragment = gql`
  fragment productTooltipFragment on Product {
    _id
    name
    code
    coverImage
    status
    price
    summary
    tags
    remarks
    fullDescription
    fullBillOfMaterials
    metadata {
      _id
      key
      value
      unit
      description
    }
    forSale
    productType
    originalPrice
    discountPercentage
    inventory {
      _id
      quantityOnHand
    }
    requiredComputedQuantityOnHand
    hasSubComponents
    baseUom {
      ...uomReferenceFragment
    }
    orderUom {
      ...uomReferenceFragment
    }
    orderConversionFactor
    purchaseUom {
      ...uomReferenceFragment
    }
    purchaseConversionFactor
    workOrderUom {
      ...uomReferenceFragment
    }
    workOrderConversionFactor
    unitOfMeasurePrecision
  }
  ${uomReferenceFragment}
`

export const productQueries = buildGraphqlQuery('Product', productTooltipFragment)
